const FILTER_TYPE = require('./advance-filter/filter-type-enum');
const _ = require('lodash');
module.exports = function ($timeout, filtersService) {
    return {
        restrict: 'E',
        scope: {},
        link(scope) {
            scope.selectedFilter = null;
            scope.isFilterPanelOpen = false;
            scope.filters = [];
            scope.filtersService = filtersService;
            scope.filterType = {
                brand: FILTER_TYPE.BRAND,
                price: FILTER_TYPE.PRICE,
                range: FILTER_TYPE.RANGE
            };

            scope.openAdvancedPanel = function (filter) {
                scope.selectedFilter = filter;
                // we want to start the animation after the ngswitch is render
                // we use timeout to start the animation at the next digest cycle
                $timeout(() => {
                    scope.isAdvancedPanelOpen = true;
                }, 0);
            };

            scope.closeAdvancedPanel = function (delay) {
                if (delay) {
                  $timeout(() => {
                    scope.isAdvancedPanelOpen = false;
                  }, 800);
                } else {
                  scope.isAdvancedPanelOpen = false;
                }
            };

            scope.applyQuickFilter = function (filter) {
                if (!filter.Results[0].Count || filter.Results[0].Count === 0) {
                  filter.Results[0].Applied = false;
                  return;
                }
                if (filter.FilterType === FILTER_TYPE.TERM) {
                  this.filtersService.applyFilter(filter.Name, {
                    Term: filter.Results[0].Name
                  });
                } else {
                  this.filtersService.applyFilter(filter.Name, {
                    Min: filter.Results[0].Min.toString(),
                    Max: filter.Results[0].Max.toString()
                  });
                }
            };

            scope.$watch('filtersService.filterByGroups', (obj) => {
                scope.filters = _.map(obj.advanceFilters, (filter) => {
                    filter.selected = null;
                    const match = _.find(scope.filtersService.appliedFilter, { Key: filter.Name });
                    if (match) {
                        filter.selected = match.Items.length;
                    }
                    return filter;
                });
            });
            filtersService.resetFilter();
        },
        template: require('./filters-mobile-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/filters-mobile-directive.js
 **/